import { render, staticRenderFns } from "./ChartBreakdown.vue?vue&type=template&id=c33b62ba&scoped=true&"
import script from "./ChartBreakdown.vue?vue&type=script&lang=js&"
export * from "./ChartBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./ChartBreakdown.vue?vue&type=style&index=0&id=c33b62ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33b62ba",
  null
  
)

export default component.exports